import { FC } from 'react';
import { FileProcess } from '../../graphql/generated';
import { AVStatus } from './av-status';
import {
  isAvFileProcess,
  isGenericFileProcess,
  isPiiFileProcess,
} from './file-process-utils';
import { GenericFileProcessStatus } from './generic-file-process-status';
import { PIIStatus } from './pii-status';

type FileProcessStatusProps = { fileProcess: FileProcess };

export const FileProcessStatus: FC<FileProcessStatusProps> = ({
  fileProcess,
}) => {
  if (isGenericFileProcess(fileProcess)) {
    return <GenericFileProcessStatus status={fileProcess.status} />;
  }
  if (isPiiFileProcess(fileProcess)) {
    return <PIIStatus status={fileProcess.piiStatus} />;
  }
  if (isAvFileProcess(fileProcess)) {
    return <AVStatus status={fileProcess.virusStatus} />;
  }

  return null;
};
